module.exports = __webpack_public_path__ + "img/genicon-icons8-light.e84f057e.svg";